import { useSearchParams } from 'react-router-dom';

export interface Period {
  year: number;
  month: number;
}

export function currentPeriod(): Period {
  const now = new Date();
  return { year: now.getFullYear(), month: now.getMonth() + 1 };
}

export function shiftPeriod({ year, month }: Period, delta: number): Period {
  const index = year * 12 + (month - 1) + delta;
  return { year: Math.floor(index / 12), month: (index % 12) + 1 };
}

/**
 * Il mese selezionato vive nell'URL: cosi' un link a un mese preciso resta
 * valido e il tasto indietro fa quello che ci si aspetta.
 */
export function usePeriod(): [Period, (p: Period) => void] {
  const [params, setParams] = useSearchParams();
  const fallback = currentPeriod();

  const year = Number(params.get('anno')) || fallback.year;
  const month = Number(params.get('mese')) || fallback.month;

  return [
    { year, month },
    (p: Period) => setParams({ anno: String(p.year), mese: String(p.month) }, { replace: true }),
  ];
}
